import { render, staticRenderFns } from "./mainList.vue?vue&type=template&id=60e98085"
import script from "./mainList.vue?vue&type=script&lang=js"
export * from "./mainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports